import { TabsLayout } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { FC, useState } from "react";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { AgentAnalyticsProvider } from "@jugl-web/domain-resources/analytics";
import { useStartSessionRecording } from "@web-src/modules/common/utils/posthogSetup";
import { BusinessImpactTabContent } from "./components/BusinessImpactTabContent";
import { ChatsOverviewTabContent } from "./components/ChatsOverviewTabContent";
import { ChatsSentimentTabContent } from "./components/ChatsSentimentTabContent";

type AnalyticsTab = "chat" | "sentiment" | "business-impact";

export const CXAnalyticsPage: FC = () => {
  useStartSessionRecording();

  const { entityId } = useEntitySelectedProvider();
  const [activeTab, setActiveTab] = useState<AnalyticsTab>("chat");
  const { t } = useTranslations();

  return (
    <AgentAnalyticsProvider entityId={entityId}>
      <TabsLayout
        breadcrumbProps={{
          items: [
            {
              title: t({
                id: "cx-analytics.analytics",
                defaultMessage: "Analytics",
              }),
            },
          ],
        }}
        selectedTab={activeTab}
        tabs={[
          {
            id: "chat",
            title: t({
              id: "cx-analytics.tab-chat",
              defaultMessage: "Chat",
            }),
            onClick: () => setActiveTab("chat"),
          },
          {
            id: "sentiment",
            title: t({
              id: "cx-analytics.tab-sentiment",
              defaultMessage: "Sentiment",
            }),
            onClick: () => setActiveTab("sentiment"),
          },
          {
            id: "business-impact",
            title: t({
              id: "cx-analytics.tab-business-impact",
              defaultMessage: "Business Impact",
            }),
            onClick: () => setActiveTab("business-impact"),
          },
        ]}
      >
        <div
          key={activeTab}
          className="mx-auto h-full w-full max-w-[1500px] animate-fade-in"
        >
          {activeTab === "chat" && <ChatsOverviewTabContent />}
          {activeTab === "sentiment" && <ChatsSentimentTabContent />}
          {activeTab === "business-impact" && <BusinessImpactTabContent />}
        </div>
      </TabsLayout>
    </AgentAnalyticsProvider>
  );
};

export default CXAnalyticsPage;
